
import React from 'react'
import Lottie from 'react-lottie'
// import animationData from '../animations/loading_screen_animation/LOADING SCREEN 2.json'
import animationData from '../../../animations/loading_screen_animation/Icon.json'
import { getDynamicHeight } from '../../../functions/utils/getDynamicHeight'
export default function LoadingDeleteAccount(): JSX.Element {
    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column  flex-center my-n8" style={{ height: getDynamicHeight() - 80 }}>
                <Lottie
                    options={{
                        animationData,
                        loop: true,
                        autoplay: true
                    }}
                    // height={100}
                    // width={100}
                    height={220}
                    width={220}
                />
                <h1 className="pt-n12 mt-n12 text-center">{'Account is in the process of deleting'}</h1>
            </div>
        </div>
    )
}
